import { useQuery } from "@tanstack/react-query";
import { useConditionalModules } from "@/hooks/useConditionalModules";
import { ModuleDisabledMessage } from "@/components/ModuleDisabledMessage";
import AppLayout from "@/components/layout/AppLayout";
import { EthicsComplianceTab } from "./dashboard/components/EthicsComplianceTab";
import { useLanguage } from "@/contexts/LanguageContext";
import { supabase } from "@/integrations/supabase/client";
import { useUser } from "@/contexts/UserContext";

const EthicsComplianceProtected = () => {
  const { isModuleEnabled, isLoading } = useConditionalModules();
  const { user } = useUser();
  const { t } = useLanguage();

  // Check if there are active policies for this user's admin bubble
  const { data: profile } = useQuery({
    queryKey: ["profile", user?.id],
    queryFn: async () => {
      if (!user?.id) return null;
      // @ts-ignore
      const { data } = await supabase
        .from("profiles")
        .select("admin_bubble_id")
        .eq("id", user.id)
        .single();
      return data;
    },
    enabled: !!user?.id,
  });

  const { data: activePolicies = [], isLoading: policiesLoading } = useQuery({
    queryKey: ["active-policies-check", profile?.admin_bubble_id],
    queryFn: async () => {
      // @ts-ignore
      if (!profile?.admin_bubble_id) return [];
      
      // @ts-ignore
      const { data, error } = await supabase
        // @ts-ignore
        .from("company_policies")
        .select("id")
        // @ts-ignore
        .eq("admin_bubble_id", profile.admin_bubble_id)
        .eq("is_active", true);

      if (error) throw error;
      return data || [];
    },
    // @ts-ignore
    enabled: !!profile?.admin_bubble_id,
  });

  const hasActivePolicies = activePolicies.length > 0;

  if (isLoading || policiesLoading) {
    return (
      <AppLayout>
        <div className="container mx-auto py-6 flex items-center justify-center min-h-[400px]">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto"></div>
            <p className="mt-4 text-muted-foreground">Loading...</p>
          </div>
        </div>
      </AppLayout>
    );
  }

  // Module is accessible if:
  // 1. It's explicitly enabled in settings, OR
  // 2. There are active policies (enabled by default when policies exist)
  const moduleAccessible = isModuleEnabled("ethics_compliance") || hasActivePolicies;

  if (!moduleAccessible) {
    return (
      <AppLayout>
        <div className="container mx-auto py-6">
          <ModuleDisabledMessage
            moduleName="ethics_compliance"
            title={t("ethicsCompliance")}
            description={t("moduleNotAvailable")}
          />
        </div>
      </AppLayout>
    );
  }

  return (
    <AppLayout>
      <div className="container mx-auto py-6 space-y-6">
        <EthicsComplianceTab />
      </div>
    </AppLayout>
  );
};

export default EthicsComplianceProtected;
